<md-checkbox
  (change)="checkboxChange($event, privilege)"
  [checked]="privilege.checkedByExtends || privilege.checked"
  [disabled]="privilege.checkedByExtends || !editMode || privilege.checkedByLogic">
</md-checkbox>



// WEBPACK FOOTER //
// ./src/app/components/privilege-checkbox/privilege-checkbox.component.html